import { createReducer } from 'src/helpers/reducer';
import { IInvoicesState, ILoadDataSuccessPayload } from './types';
import actionsTypes from './actionTypes';

const initState: IInvoicesState = {
  invoices: undefined,
  isLoading: false,
  total: 0,
};

function onLoadInvoicesRequest(state: IInvoicesState): IInvoicesState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadInvoicesSuccess(
  state: IInvoicesState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IInvoicesState {
  const { invoices, total, filteredTotal } = payload;

  return {
    ...state,
    invoices,
    total,
    filteredTotal,
    isLoading: false,
  };
}

function onLoadInvoicesError(state: IInvoicesState) {
  return {
    ...state,
    invoices: [],
    isLoading: false,
  };
}

function onClearStore() {
  return initState;
}

export default createReducer(initState, {
  [actionsTypes.LOAD_INVOICES_REQUEST]: onLoadInvoicesRequest,
  [actionsTypes.LOAD_INVOICES_SUCCESS]: onLoadInvoicesSuccess,
  [actionsTypes.LOAD_INVOICES_ERROR]: onLoadInvoicesError,
  [actionsTypes.CLEAR_STORE]: onClearStore,
});
